module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0008#acknow"
    }
  }, [_vm._v("Acknowledgments ix")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0010#prog"
    }
  }, [_vm._v("Prologue: Do the Dead Choose Their Biographers?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0011#ch01"
    }
  }, [_vm._v("1  The Search for Companionship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0012#ch02"
    }
  }, [_vm._v("2 “Between the Old and the New”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0013#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Falling in Love: The Exuberant Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0014#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 A Star Is Born")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0015#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Making a Home in Kittery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0016#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Shining in a Dark Time: Politics and Painting in the Depression")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0017#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 In Sickness and in Health: The Hartford Retreat, McLean Hospital, and Baldpate Hospital")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0018#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Green Light across the Piscataqua")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0019#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Losing Touch: Life without Cheney")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0020#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Aftermath and Afterglow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0021#epil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Getting Married After All")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0022#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/uma_Bane0024#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057b7ef6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma_Bane0007.vue
// module id = 75
// module chunks = 0